import { gql } from '@apollo/client'

export const GET_MY_MARKET_BIDS = gql`
  query GetMyMarketBids($fantasyLeagueId: ID!) {
    visibleBids(fantasyLeagueId: $fantasyLeagueId) {
      id
      amount
      marketEntry {
        id
      }
      bidder {
        id
      }
    }
  }
`
